<template>
    <input
        class="form-check-input"
        type="radio"
        :value="value"
        @change="onChange"
        :checked="isChecked"
    >
</template>

<script>
export default {
    model: {
        prop: 'modelValue',
        event: 'change'
    },
    props: {
        value: {
            type: String | Boolean
        },
        modelValue: {
            default: ''
        }
    },
    computed: {
        isChecked() {
            return this.modelValue === this.value;
        }
    },
    methods: {
        onChange(event) {
            this.$emit('change', event.target.value);
        }
    }
}
</script>
